import {createPersister} from '@github-ui/react-query-persister'
import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'
import type {IssueTypePickerIssueType} from '@github-ui/item-picker-issue-type'

function isIssueType(obj: unknown): obj is IssueTypePickerIssueType {
  if (typeof obj !== 'object' || obj === null) return false
  const item = obj as Record<string, unknown>
  return (
    typeof item.id === 'string' &&
    typeof item.name === 'string' &&
    (typeof item.description === 'string' || item.description === null || item.description === undefined) &&
    typeof item.color === 'string' &&
    (typeof item.isEnabled === 'boolean' || item.isEnabled === undefined)
  )
}

export function isIssueTypePickerQueryData(obj: unknown): obj is {issueTypes: IssueTypePickerIssueType[]} {
  if (typeof obj !== 'object' || obj === null) return false
  const data = obj as {issueTypes?: unknown}
  return Array.isArray(data.issueTypes) && data.issueTypes.every(isIssueType)
}

const IssueTypePickerQueryDataValidator = {
  Check: (value: unknown): value is {issueTypes: IssueTypePickerIssueType[]} => isIssueTypePickerQueryData(value),
  Code: () => 'manual-validator',
  *Errors() {
    /* no-op */
  },
}

export function createIssueTypePersister(sendAnalyticsEvent: SendAnalyticsEventFunction) {
  return createPersister({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: IssueTypePickerQueryDataValidator as any,
    sendAnalyticsEvent,
    alwaysRefetch: true,
    enabled: true,
  })
}
